export const FLUSH = 'persist/FLUSH';
export const PERSIST = 'persist/PERSIST';
export const REHYDRATE = 'persist/REHYDRATE';
export const REHYDRATED = 'persist/REHYDRATED';

export const STORAGE_PREFIX = 'persist::';
export const METADATA_KEY = '__PERSIST__';

// If persisted data that doesn't seem to be registered is older than this, we will purge it
export const INVALID_STORAGE_GRACE_PERIOD = 14 * 24 * 60 * 60 * 1000;
